export const business = {
  name: 'PA Concreto & Asphalt',
  owner: 'Pablo Adame',
  phoneDisplay: '+1 (708) 632-0587',
  phoneHref: 'tel:+17086320587',
  hours: { en: 'Mon – Sat, 7:00 AM – 6:00 PM', es: 'Lun – Sáb, 7:00 AM – 6:00 PM' },
  serviceArea: { en: 'Chicagoland & surrounding suburbs', es: 'Chicagoland y suburbios cercanos' },
  heroImage: 'https://cdn.magicpatterns.com/uploads/uKftknjhiPEfgFwBvc38aB/Banner_PA_Concrete.jpg',
};

export const navLinks = [
  { label: { en: 'Services', es: 'Servicios' }, href: '#services' },
  { label: { en: 'Process', es: 'Proceso' }, href: '#process' },
  { label: { en: 'Gallery', es: 'Galería' }, href: '#gallery' },
  { label: { en: 'FAQ', es: 'Preguntas' }, href: '#faq' },
  { label: { en: 'Contact', es: 'Contacto' }, href: '#contact' },
];

export const footerLinks = [
  { label: { en: 'Services', es: 'Servicios' }, href: '#services' },
  { label: { en: 'Our Process', es: 'Nuestro Proceso' }, href: '#process' },
  { label: { en: 'Portfolio', es: 'Portafolio' }, href: '#gallery' },
  { label: { en: 'FAQ', es: 'Preguntas Frecuentes' }, href: '#faq' },
  { label: { en: 'Service Areas', es: 'Áreas de Servicio' }, href: '#areas' },
  { label: { en: 'Contact', es: 'Contacto' }, href: '#contact' },
  { label: { en: 'Privacy', es: 'Privacidad' }, href: '#' },
];
